// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ed3be676","455":"f4d2129e","977":"a212bad3"}[chunkId] + ".chunk.js";
};